import styled from 'styled-components';
import {
  SpacingProps as MuiSpacingProps,
  TypographyProps as MuiTypographyProps,
  SizingProps,
  PaletteProps,
  BordersProps,
  FlexboxProps,
  ShadowsProps,
  DisplayProps,
  PositionsProps,
  positions as positionStyles,
  display as displayStyles,
  shadows as shadowStyles,
  flexbox as flexboxStyles,
  borders as borderStyles,
  sizing as sizingStyles,
  typography as typographyStyles,
  spacing as spacingStyles,
  palette as paletteStyles,
} from '@material-ui/system';

type SpacingPropsKeys = 'margin'
  | 'marginTop'
  | 'marginRight'
  | 'marginBottom'
  | 'marginLeft'
  | 'padding'
  | 'paddingTop'
  | 'paddingRight'
  | 'paddingBottom'
  | 'paddingLeft';

type SpacingProps = Pick<MuiSpacingProps, SpacingPropsKeys>;
type TypographyProps = Pick<MuiTypographyProps, 'textAlign'>;

// All the different text tags (and div) we want to support
type VariantType = 'div'
  | 'section'
  | 'article'
  | 'nav'
  | 'header'
  | 'footer'
  | 'span'
  | 'li'
  | 'ol'
  | 'ul'
  | 'form';

type BaseBoxProps = {
  as?: VariantType,
  float?: string,
  transform?: string,
}
& BordersProps
& DisplayProps
& FlexboxProps
& PaletteProps
& PositionsProps
& SizingProps
& ShadowsProps
& SpacingProps
& TypographyProps;

const PROPS_NO_FORWARD = [
  'display',
  'overflow',
  'width',
  'height',
];

const Box = styled('div').withConfig({
  // Prevent styles from being passed to html element directly
  shouldForwardProp: (prop, validator) => !PROPS_NO_FORWARD.includes(prop) && validator(prop),
})<BaseBoxProps>`
  float: ${(props) => props.float};
  transform: ${(props) => props.transform};
  ${borderStyles}
  ${displayStyles}
  ${flexboxStyles}
  ${paletteStyles}
  ${positionStyles}
  ${sizingStyles}
  ${shadowStyles}
  ${spacingStyles}
  ${typographyStyles}
`;

export default Box;
